module.exports = __webpack_public_path__ + "static/media/30.1f812b96.png";